exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 769px) {\n  .fakemobilemenu {\n    right: 0px;\n    position: absolute;\n    width: 6.2rem;\n    height: 6.2rem;\n    float: right;\n    z-index: 10; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main